/**
 * Sober DS (v2) — Financeiro money helpers. The engine stores amounts in cents
 * (ADR-1, unchanged); these only format for display and parse user input back to
 * cents for the existing mutations.
 */
export function formatBRL(cents: number): string {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(
    (cents ?? 0) / 100
  );
}

/** Compact "+ R$ 1.200" / "− R$ 840" signed label for transaction rows. */
export function formatSignedBRL(cents: number, type: 'income' | 'expense'): string {
  const sign = type === 'income' ? '+ ' : '− ';
  return sign + formatBRL(Math.abs(cents ?? 0));
}

export const MASKED_BRL = 'R$ ••••';
export const MASKED_PCT = '••%';

export function maskBRL(): string {
  return MASKED_BRL;
}

/** Parse a pt-BR money string ("1.200,50") into integer cents. */
export function parseReaisToCents(value: string): number {
  const normalized = value
    .replace(/[^\d,.-]/g, '')
    .replace(/\./g, '')
    .replace(',', '.');
  const num = Number.parseFloat(normalized);
  return Number.isFinite(num) ? Math.round(num * 100) : 0;
}
